/**
 * @name mediaGroup_node
 */
export const mediaGroup = {
  inline: false,
  group: 'block',
  content: '(media|unsupportedBlock)+',
  attrs: {},
  marks: 'unsupportedMark unsupportedNodeAttribute',
  selectable: false,
  parseDOM: [{
    tag: 'div[data-node-type="mediaGroup"]'
  }, {
    tag: 'div[class="MediaGroup"]'
  }],

  toDOM() {
    return ['div', {
      'data-node-type': 'mediaGroup'
    }, 0];
  }

};